export default __webpack_public_path__ + "static/media/AdobeStock_39399584.25698a15.jpg";